import { service_paths } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

const filterOptions = {
  computed: {
    ...mapGetters("user", {
      userRole: "role",
      userInfo: "info"
    })
  },
  methods: {
    fetchTerms() {
      const queryParams = this.getTermQueryByRole();

      return this.$axios
        .get(service_paths.terms, queryParams)
        .then(({ data: resData }) => {
          const { data: terms } = resData;
          return this.formatTerms(terms);
        });
    },

    fetchClasses(termId) {
      if (!termId) return;

      const queryParams = {
        limit: 200,
        term_id: termId
      };

      return this.$axios
        .get(service_paths.classes, queryParams)
        .then(({ data: resData }) => {
          const { data: classes } = resData;
          return this.formatClasses(classes);
        });
    },

    formatTerms(terms) {
      return terms.map(term => ({
        id: getId(term),
        name: term.name
      }));
    },

    formatClasses(classes) {
      return classes.map(classObj => ({
        id: getId(classObj),
        name: classObj.name
      }));
    },

    getTermQueryByRole() {
      const baseQueryObj = {
        limit: 200,
        order_by: "created_at ASC"
      };

      if (hasValidRole(this.userRole, Role.Teacher)) {
        const techerId = getId(this.userInfo);
        return {
          ...baseQueryObj,
          teacher_id: techerId
        };
      }

      return baseQueryObj;
    }
  }
};

const baseFormSearch = {
  props: ["defaultTerms", "defaultClasses"],
  data() {
    return {
      baseFormSearch: [
        {
          label: this.$t("common.term"),
          name: "term_id",
          value: "",
          type: "select",
          options: [],
          onSelected: this.onSelectTerm
        },
        {
          label: this.$t("common.class"),
          name: "class_ids",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "id",
          displayField: "name",
          showSelectAll: true
        }
      ],
      hasFirstSelectedTerm: false
    };
  },
  computed: {
    termId() {
      return this.baseFormSearch[0].value;
    }
  },
  methods: {
    setNewTerms(newTerms) {
      this.baseFormSearch[0].options = newTerms;
    },
    setNewSelectedTerm(termId) {
      this.baseFormSearch[0].value = termId;
    },
    setNewClasses(newClasses) {
      this.baseFormSearch[1].options = newClasses;
    },
    setNewSelectedClasses(classIds) {
      this.baseFormSearch[1].value = [...classIds];
    },
    onSelectTerm(termId) {
      if (!this.hasFirstSelectedTerm) {
        this.hasFirstSelectedTerm = true;
        return;
      }

      this.fetchClasses(termId).then(classes => {
        this.setNewClasses(classes);
        this.setNewSelectedClasses(classes.map(classObj => getId(classObj)));
      });
    },
    isSelectAllClass(selectedClassIds) {
      return selectedClassIds.length === this.baseFormSearch[1].options.length;
    }
  },
  watch: {
    defaultTerms: function(newTerms) {
      const firstTermId = getId(newTerms[0]);
      this.setNewTerms(newTerms);
      this.setNewSelectedTerm(firstTermId);
    },
    defaultClasses: function(newClasses) {
      const classIds = newClasses.map(classObj => getId(classObj));

      this.setNewClasses(newClasses);
      this.setNewSelectedClasses(classIds);
    }
  }
};

export { filterOptions, baseFormSearch };
